import { module } from 'angular';

import { default as recipientsInfoTooltipDirectiveName, RecipientsInfoTooltipDirective } from './recipients-info-tooltip.directive';

export default module('contact.commons.toolbox.recipients-info-tooltip', []).directive(
  recipientsInfoTooltipDirectiveName,
  RecipientsInfoTooltipDirective
).name;
